import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/refresh.svg";
var RefreshOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  RefreshOutline_default as default
};
